export default "__VITE_ASSET__CgW3h1V6__"